import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment.development';

interface EmailResponse {
  status: string;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(private http: HttpClient) { }

  private apiServicesUrl = environment.cfgApiBaseUrl;

  sendEmail(name: string, email: string, subject: string, message: string): Observable<EmailResponse> {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }
    return this.http.post<EmailResponse>(this.apiServicesUrl + '/say-hi', 
      {'name': name, 'email': email, 'subject': subject, 'message': message}, httpHeaders)
    .pipe(
      catchError(err => { return throwError(() => err) })
    );
  }

}
